// extracted by mini-css-extract-plugin
module.exports = {"section":"LoadingSection_section__3XT53","spinner":"LoadingSection_spinner__3ORmu"};